/**
 * Module dependencies.
 */

import { fetchGraphql } from 'utils/fetch-graphql';
import { normalizeList, normalizeSingleObject } from 'utils/normalizers';
import { pickSocialNetworks } from 'utils/social-networks';

/**
 * Query.
 */

const QUERY = `
    query {
      homegallery {
        id
        image {
          width
          height
          title
          type
          filename_download
          filename_disk
        }
        color
        translations {
          languages_code {
            code
          }
          title
          description
          category
        }
      }

      products {
        id
        image {
          width
          height
          title
          type
          filename_download
          filename_disk
        }
        translations {
          languages_code {
            code
          }
          title
          description
        }
      }

      Company {
        facebook
        instagram
        twitter
        pinterest
        linkedin
        youtube
        store {
          width
          height
          title
          type
          filename_download
          filename_disk
        }
        translations {
          languages_code {
            code
          }
          description
        }
      }

      services {
        id
        image {
          width
          height
          title
          type
          filename_download
          filename_disk
        }
        translations {
          languages_code {
            code
          }
          title
          description
        }
      }
    }
  `;

/**
 * Export `homeStaticProps`.
 */

export function homeStaticProps() {
  try {
    return fetchGraphql(QUERY).then((data) => {
      const result: any = {};

      result.homegallery = normalizeList(data.homegallery);
      result.products = normalizeList(data.products);
      result.company = normalizeSingleObject(data.Company);
      result.services = normalizeList(data.services);
      result.socialNetworks = pickSocialNetworks(data.Company);

      return result;
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);

    throw error;
  }
}
